module.exports = __webpack_public_path__ + "img/school_guide.a2287d8d.jpg";